import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PROFILE, LINKS } from "@/content";

const Section = ({ title, children }) => (
  <section className="mb-12">
    <h2 className="font-display text-2xl tracking-tight mb-4">{title}</h2>
    <div className="text-sm text-zinc-400 leading-relaxed space-y-3">{children}</div>
  </section>
);

export default function Impressum() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="impressum-page" className="min-h-screen bg-[#050505] text-zinc-100 grain">
      <div className="max-w-3xl mx-auto px-6 py-16 md:py-24">
        <Link
          data-testid="impressum-back-link"
          to="/"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-zinc-500 hover:text-white transition-colors duration-300 mb-12"
        >
          <ArrowLeft size={14} /> Zurück zur Website
        </Link>

        <h1 className="font-display text-4xl md:text-5xl tracking-tight mb-16">Impressum & Datenschutz</h1>

        <Section title="Kontakt">
          <p>
            {PROFILE.name}
            <br />
            Täfernstrasse 14a
            <br />
            5405 Dättwil, Schweiz
          </p>
          <p>
            E-Mail:{" "}
            <a data-testid="impressum-email" href={`mailto:${PROFILE.email}`} className="text-zinc-200 hover:text-white transition-colors duration-300">
              {PROFILE.email}
            </a>
            <br />
            Telefon:{" "}
            <a data-testid="impressum-phone" href={`tel:${PROFILE.phone.replace(/\s/g, "")}`} className="text-zinc-200 hover:text-white transition-colors duration-300">
              {PROFILE.phone}
            </a>
          </p>
        </Section>

        <Section title="Haftung für Inhalte">
          <p>
            Die Inhalte dieser Website wurden mit Sorgfalt erstellt. Für Richtigkeit, Vollständigkeit und
            Aktualität wird keine Gewähr übernommen. Diese Website dient der Präsentation der schauspielerischen
            Tätigkeit von {PROFILE.name}.
          </p>
        </Section>

        <Section title="Haftung für Links">
          <p>
            Diese Website enthält Links zu externen Websites Dritter (z. B.{" "}
            <a href={LINKS.instagram} target="_blank" rel="noopener noreferrer" className="text-zinc-200 hover:text-white transition-colors duration-300">Instagram</a>,{" "}
            <a href={LINKS.imdb} target="_blank" rel="noopener noreferrer" className="text-zinc-200 hover:text-white transition-colors duration-300">IMDb</a>,{" "}
            <a href={LINKS.linkedin} target="_blank" rel="noopener noreferrer" className="text-zinc-200 hover:text-white transition-colors duration-300">LinkedIn</a>).
            Auf deren Inhalte habe ich keinen Einfluss; dafür ist stets der jeweilige Anbieter verantwortlich.
          </p>
        </Section>

        <Section title="Urheberrecht">
          <p>
            Alle Inhalte dieser Website — insbesondere Fotos, Videos und Texte — sind urheberrechtlich geschützt.
            Jede Verwendung ausserhalb der Grenzen des Urheberrechts bedarf der vorherigen schriftlichen
            Zustimmung von {PROFILE.name}.
          </p>
        </Section>

        <Section title="Datenschutz">
          <p>
            <strong className="text-zinc-200">Kontaktformular:</strong> Angaben aus dem Kontaktformular (Name,
            E-Mail-Adresse, Nachricht) werden ausschliesslich zur Bearbeitung deiner Anfrage gespeichert und
            nicht an Dritte weitergegeben.
          </p>
          <p>
            <strong className="text-zinc-200">Eingebettete Videos:</strong> Beim Abspielen des Showreels werden
            Daten an YouTube (Google) übertragen. Es gilt die Datenschutzerklärung von Google.
          </p>
          <p>
            <strong className="text-zinc-200">Cookies:</strong> Diese Website verwendet keine Tracking-Cookies.
            Lediglich deine Sprachwahl (Deutsch/Englisch) wird lokal in deinem Browser gespeichert.
          </p>
          <p>
            Du hast jederzeit das Recht auf Auskunft, Berichtigung oder Löschung deiner gespeicherten Daten.
            Schreib dazu einfach an {PROFILE.email}.
          </p>
        </Section>

        <p className="text-xs text-zinc-600 mt-16">Stand: August 2026 — {PROFILE.name}, {PROFILE.location || "Zürich, Schweiz"}</p>
      </div>
    </div>
  );
}
